import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=535b6a4a&scoped=true"
import script from "./newsdetails.vue?vue&type=script&lang=js"
export * from "./newsdetails.vue?vue&type=script&lang=js"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=535b6a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b6a4a",
  null
  
)

export default component.exports